<template>
    <div class="banner-contato banner wow animate__animated animate__fadeInRightBig">
        <h1>Contato</h1>
    </div>
    <div class="container py-5">
        <div class="row row-contato wow animate__animated animate__fadeInLeftBig">
            <div class="col-sm-12 col-md-4 col-lg-4">
                <div class="box">
                    <h3>Queremos ouvir você!</h3>
                    <p>Você pode nos contatar através dos seguintes canais:</p>
                
                    <ul>
                        <li>E-mail: contato@exemplo.com</li>
                        <li>Telefone: +(11) 1234-5678</li>
                    </ul>

                    <p>Ou, se preferir, preencha o formulário a seguir e retornaremos para você o mais breve possível. Estamos ansiosos para ajudar!</p>
                </div>                
            </div>
            <div class="col-sm-12 col-md-8 col-lg-8">
                <form action="">
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingName" placeholder="Nome Completo">
                        <label for="floatingInput">Nome</label>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-floating mb-3">
                        <input type="email" class="form-control" id="floatingMail" placeholder="name@example.com">
                        <label for="floatingInput">E-mail</label>
                    </div>
                </div>
                
                <div class="col-12">
                    <div class="form-floating mb-3">
                        <textarea class="form-control" placeholder="Deixe uma mensagem" id="floatingTextarea" style="height: 180px"></textarea>
                        <label for="floatingTextarea">Mensagem</label>
                    </div>
                </div>
                <div class="col-12">
                    <button class="btn btn-outline-primary">
                        Enviar Mensagem
                    </button>
                </div>
            </div>
        </form>

            </div>
        </div>


        
    </div>
</template>

<script>
export default {
    name: 'ContatoPage',
};
</script>

<style scoped>
/* estilos específicos do componente */
</style>